import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { LevelService } from 'src/app/services/lobby/level.service';

@Component({
    selector: 'app-game-tile-label',
    templateUrl: './game-tile-label.component.html',
    styleUrls: ['./game-tile-label.component.scss']
})
export class GameTileLabelComponent implements OnInit {

    @Input() data: any;
    //protected currentLevel$: Observable<number>;
    //protected unlockLevel: number;

    constructor(
        private readonly levelService: LevelService,
    ) {

    }

    ngOnInit(): void {
        // this.currentLevel$ = this.levelService.level$;
        // this.unlockLevel = this.data?.unlock_level;
    }
}